<template>
  <section class="card invoice-preview-wrapper">
      <b-card class="mb-0" v-if="userEvaluation && (userEvaluation.status === 'TERMINATED'||  (userEvaluation.status === 'EVALUATION' && userEvaluation.dateEvaluationPropose))">
        <div>
          <!-- Affichage des dates proposées & suggérées -->
          <div v-if="(userEvaluation.dateEvaluationPropose || userEvaluation.dateEvaluationPrevu) && !userEvaluation.valid">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="text-danger mb-0">Date de Rencontre</h5>

              <!-- Accepter Date proposée ou non -->
              <div class="d-flex " v-if="!userEvaluation.dateEvaluationPrevu && userEvaluation.dateEvaluationPropose">
                <b-form-group>
                  <b-form-checkbox
                      class="custom-control-primary mb-0"
                      name="check-button"
                      v-model="dateEvaluationAccepted"
                      switch
                  >
                    Valider date proposée
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </div>
            <hr class="my-2">

            <div class="d-flex justify-content-between">
              <div>
                <div class="mb-2">
                  <div v-if="userEvaluation.dateEvaluationPrevu">
                    Le rendez-vous pour la validation de l'évaluation a été retenu à la date du : {{ userEvaluation.dateEvaluationPrevu }}.
                  </div>

                  <div>
                    <p v-if="userEvaluation.dateEvaluationPropose && !userEvaluation.dateEvaluationPrevu"> {{ userEvaluation.users.usersHierarchique[0].civilityFullName }}
                      a proposé la date du <strong>{{ userEvaluation.dateEvaluationPropose }}</strong>.</p>

                    <p v-if="userEvaluation.dateEvaluationSuggest">Vous avez suggéré la date du <strong>{{ userEvaluation.dateEvaluationSuggest }}</strong></p>
                  </div>
                </div>

                <!-- Composant sélection des dates -->
                <div v-if="!dateEvaluationAccepted">
                  <evaluation-date-scheduler
                      :user-data="userData"
                      :current-year="currentYear"
                      :manager="false"
                      :user-evaluation.sync="userEvaluation"
                  />
                </div>

                <!-- Validation de la date proposée par le manager -->
                <div class="d-flex" v-if="!userEvaluation.dateEvaluationPrevu && userEvaluation.dateEvaluationPropose">
                  <b-button variant="primary" @click="validateProposedDate" v-if="dateEvaluationAccepted">
                    <feather-icon size="16" icon="CheckIcon" class="mr-50" />
                    <span class="align-middle"> Valider </span>
                  </b-button>
                </div>
              </div>

              <div><b-img :src="require('@/assets/images/pages/calendar-illustration.png')" width="140" height="auto" /></div>
            </div>
          </div>

        </div>
      </b-card>
  </section>
</template>

<script>
import { BButton, BCard } from 'bootstrap-vue';
import {
  getUserEvaluationsByYears,
  updateDateEvaluationMeeting,
} from '@/services/UserEvaluationService';
import {allYears} from '@/services/YearsService';
import {getSetting} from '@/services/SettingService';
import Ripple from 'vue-ripple-directive';
import moment from 'moment'
import EvaluationDateScheduler from "@/views/profil/EvaluationDateScheduler.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {getJsonFromStorage} from "@/util/storageUtils";


export default {
  directives: {
    Ripple,
  },
  components: {
    EvaluationDateScheduler,
    BCard,
    BButton,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateEvaluationAccepted: true,
      userEvaluation: null,
      currentYear: null,
      years: [],
      signatureValidUser: [],
    };
  },
  computed: {
    isEvaluationValid() {
      return this.userEvaluation && this.userEvaluation.valid;
    },
    evaluationCanBeEdited() {
      if (!this.userEvaluation) return false;

      const status = this.userEvaluation.status;

      if (['EVALUATION', 'SELF_EVALUATION', 'TERMINATED','INPROGRESS'].includes(status)) {
        return true;
      }

      if (status === 'MEETING') {
        const dateStr = this.userEvaluation.dateEvaluationPropose || this.userEvaluation.dateEvaluationPrevu;

        if (!dateStr) {
          return true;
        }

        const datePrevue = this.getEvaluationDateWithHourSubstracted(dateStr);

        if (!datePrevue || !datePrevue.isValid()) {
          return true;
        }

        return moment().isBefore(datePrevue);
      }

      return false;
    },
    yearOptions() {
      return this.years.map(year => ({
        value: year.year,
        text: `${year.year}`,
      }));
    },
  },
  watch: {
    currentYear(newYear, oldYear) {
      this.fetchUserEvaluationData(newYear);
    },
  },
  methods: {
    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData')
      return storedUserData ? storedUserData : null
    },
    async validateProposedDate() {


      updateDateEvaluationMeeting(this.userEvaluation.idPublic, this.userEvaluation,'USER_ACCEPT')
          .then(result => {
            if (result.status === "MEETING") {

              this.fetchUserEvaluationData(this.currentYear)

              this.showToast("Date enregistrée avec succès", "success", "BellIcon");
            } else {
              this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            }
          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            console.error("Erreur lors de la récupération des données :", error);
          });
    },
    formatDate(date) {
      if (!date) return '';
      if (Array.isArray(date)) {
        const [year, month, day] = date;
        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }
      if (typeof date === 'string') {
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      console.error('Invalid date format:', date);
      return '';
    },
    async fetchUserEvaluationData(currentYear) {

      if (!this.userData || !this.currentYear) {
        console.warn('Missing userData or currentYear, aborting fetch',this.userData);
        return;
      }
      try {
        const userDataConnected = this.getStoredUserData();

        const response = await getUserEvaluationsByYears(this.userData.id,userDataConnected.id, currentYear);

        if (!response) {
          this.userEvaluation = null;
          return;
        }

        this.userEvaluation = response;

      } catch (error) {
        console.error('Error in fetchUserEvaluationData:', error);
      }

    },

    async getAllYears() {
      try {
        this.years = await allYears();
        if (!this.currentYear && this.years.length) {
          this.currentYear = this.years[0].year;
        }
      } catch (error) {
        console.error('Error fetching years:', error);
      }
    },

    // handleClick() {
    //   // Vérifier si dateEvaluationPrevu existe
    //   if (!this.userEvaluation.dateEvaluationPrevu) {
    //     this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });
    //     return;
    //   }
    //
    //   // Nettoyer la chaîne pour éviter les espaces ou caractères invisibles
    //   const cleanedDate = this.userEvaluation.dateEvaluationPrevu.trim();
    //
    //   // Parser la date
    //   const datePrevue = dayjs(cleanedDate, "DD-MM-YYYY HH:mm", true);
    //
    //   // Vérifier si la date est valide
    //   if (!datePrevue.isValid()) {
    //     console.error("Date prévue invalide:", cleanedDate);
    //     this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });
    //     return;
    //   }
    //
    //   // Vérifier le statut
    //   if (
    //       this.userEvaluation.status === 'EVALUATION' ||
    //       this.userEvaluation.status === 'SELF_EVALUATION' ||
    //       this.userEvaluation.status === 'TERMINATED'
    //   ) {
    //     this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });
    //   } else {
    //     const datePrevueMinus1h = datePrevue.subtract(1, 'hour');
    //     const today = dayjs();
    //

    //
    //     if (datePrevueMinus1h.isBefore(today)) {
    //       this.$router.push({ name: 'all_evaluation_print', params: { id: this.userEvaluation.idPublic } });
    //     } else {
    //       this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });
    //     }
    //   }
    // },

    handleClick() {

      if (this.userEvaluation.status === 'EVALUATION' || this.userEvaluation.status === 'SELF_EVALUATION' || this.userEvaluation.status === 'TERMINATED' ) {

        this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });
      } else {

        const datePrevue = this.getEvaluationDateWithHourSubstracted(this.userEvaluation.dateEvaluationPrevu)
        const isCurrentDateAvailable = datePrevue.isBefore(moment());

        if (isCurrentDateAvailable) {
          this.$router.push({ name: 'all_evaluation_print', params: { id: this.userEvaluation.idPublic } });

        } else {
          this.$router.push({ name: 'auto_evaluation_print', params: { id: this.userEvaluation.idPublic } });

        }

      }
    },
    getEvaluationDateWithHourSubstracted(date) {
      if(!date) {
        this.showToast('Erreur', 'La date de validation est manquante', 'danger');
        return;
      }

      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);
      // const currentDateMinus1h = currentDate.subtract(1, 'days');
      const currentDateMinus36h = currentDate.subtract(36, 'hours');


      return currentDateMinus36h;
    }
    , showToast(variant, position, text) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'InfoIcon',
              text,
              variant,
            },
          },
          { position }
      );
    },
  },
  async mounted() {
    await this.getAllYears();
    try {
      const response = await getSetting();
      if (response && response.yearEvaluation) {
        this.currentYear = response?.yearEvaluation?.year;
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      this.currentYear = this.years.length ? this.years[0].year : new Date().getFullYear();
    }
    await this.fetchUserEvaluationData(this.currentYear);
  },
};
</script>

<style scoped>
.budget-dropdown {
  width: 80px;
  border: 1px solid #005cb9;
  border-radius: 0.357rem;
  background-color: #fff;
  font-size: 1rem;
  line-height: 1.45;
  color: #005cb9;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.budget-dropdown:focus,
.budget-dropdown:active {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.2);
  outline: none;
}

fieldset {
  margin-bottom: 0;
}
</style>
